export enum FieldType {
    Dropdown = 1,
    Text = 2,
    Taxonomy = 3,
    TaxonomyFields = 4, // Is not being used now (for future use)
    Date = 5,
    Number = 6, // Is not being used now (for future use)
    MDMData = 7,
    MDMSearch = 8,
    Static = 9,
    TaxonomyId = 10
}